module.exports = __webpack_public_path__ + "static/img/excep_blankpage_def.4425db0e.png";